// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3zjmt","col":"Table_col__2_0SH","fulfillmentStatus":"Table_fulfillmentStatus__qBGoK","emailCol":"Table_emailCol__1Fj-a"};